// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vxsmgscxnfkvebvgyazy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ4c21nc2N4bmZrdmVidmd5YXp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg3MTgxNDYsImV4cCI6MjA2NDI5NDE0Nn0.igrgAD0kZrmTbw6CFU4qUqFSOlgalsoblkVuDgbi6KY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);